import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type BadgeVariant = "success" | "warning" | "danger" | "info" | "neutral" | "primary";
type BadgeSize = "sm" | "md" | "lg";

export type BadgeProps = {
    label?: string;
    variant?: BadgeVariant;
    size?: BadgeSize;
    rounded?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    label: { default: "" },
    variant: { default: "neutral" },
    size: { default: "md" },
    rounded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { label: string, variant: BadgeVariant, size: BadgeSize, rounded: boolean };



const badgeClasses = computed(() => ([
    "app-badge",
    `app-badge--${props.variant}`,
    `app-badge--${props.size}`,
]));

return { __sfc: true,props, badgeClasses }
}

})